export abstract class RespuestaBase {
  tipoRespuesta?: string;
  exito?: boolean;
  mensaje?: string;
}
